module.exports = __webpack_public_path__ + "static/media/sfl_11.1b0ec901.jpg";